export default "__VITE_ASSET__C_HhJnU7__"